import { CheckCircle, EventBusy, Cancel } from '@mui/icons-material'
import type { ComponentType, CSSProperties } from 'react'
import { ConsultationRowStatus } from '../types'

export const STATUS_GREEN = '#1fba5d'
export const STATUS_ORANGE = '#ff5100'
export const STATUS_RED = '#e33d3d'

export const consultationStatusColor = (
  status: ConsultationRowStatus
): string => {
  if (status === 'attended') return STATUS_GREEN
  if (status === 'noShow') return STATUS_ORANGE
  return STATUS_RED
}

export const consultationStatusIcon = (
  status: ConsultationRowStatus
): ComponentType<{ style?: CSSProperties }> => {
  if (status === 'attended') return CheckCircle
  if (status === 'noShow') return EventBusy
  return Cancel
}

export const consultationStatusLabelKey = (
  status: ConsultationRowStatus
): string => {
  if (status === 'attended')
    return 'financial.monthlyHistory.detail.statusAttended'
  if (status === 'noShow') return 'financial.monthlyHistory.detail.statusNoShow'
  return 'financial.monthlyHistory.detail.statusCanceled'
}
